import panoramaObrez from './panorama_obrez.jpg'
import photo1 from './photo1.jpg'
import photo2 from './photo2.jpg'
import thumb1 from './thumb1.jpg'
import thumb2 from './thumb2.jpg'
import thumb3 from './thumb3.jpg'
import thumb4 from './thumb4.jpg'
import thumb5 from './thumb5.jpg'
import thumb6 from './thumb6.jpg'
import image1 from './image1.jpg'
import image2 from './image2.jpg'
import image3 from './image3.jpg'
import image4 from './image4.jpg'
import image5 from './image5.jpg'
import image6 from './image6.jpg'
import cafe2 from './cafe_2.jpg'

export { panoramaObrez, photo1, photo2, thumb1, thumb2, thumb3, thumb4, thumb5, thumb6,
  image1, image2, image3, image4, image5, image6, cafe2}



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/Cafe/images/index.js